import { memo } from 'react';
import {
  interpolate,
  Extrapolation,
  useAnimatedStyle,
} from 'react-native-reanimated';
import { Box, Text } from '@bonanza-social/moonlight';
import { MISS_POSITION } from '../PrizeWallPrizes/PrizeWallPrizes.content';
import { PrizeWallMissProps } from './PrizeWallMiss.types';
import PrizeWallPrizeBackground from '../PrizeWallPrizes/PrizeWallPrize/PrizeWallPrizeBackground/PrizeWallPrizeBackground';

function PrizeWallMiss({ missed, animatedValue }: PrizeWallMissProps) {
  const animatedStyle = useAnimatedStyle(() => ({
    opacity: interpolate(
      animatedValue.value - MISS_POSITION,
      [0, 0.5, 1],
      [0, 1, 0],
      Extrapolation.CLAMP,
    ),
  }));

  return (
    <Box height="space-1000" centerContent>
      <PrizeWallPrizeBackground variant="default" />
      <PrizeWallPrizeBackground
        variant={missed ? 'missed' : 'focused'}
        animatedStyle={animatedStyle}
      />
      <Text
        locNS="prizeWall"
        locKey="prizeWallMiss"
        variant="body-s-semi"
        color="darkSurfacePrimary"
      />
    </Box>
  );
}

export default memo(PrizeWallMiss);
